module.exports = __webpack_public_path__ + "images/img-egdem0S.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/postback-info/en/4.png
// module id = 2324
// module chunks = 0